module.exports = __webpack_public_path__ + "media/images/slider_2-60e342ed184db7b99405d6d4399892df.png";